import { IUser, IUserRequest, IUserResponse } from "interfaces/user";

export const formateUserRequestData = (user: IUserRequest): IUserResponse => {
	const userPayload: IUserResponse = {
		first_name: user.firstName,
		last_name: user.lastName,
		email: user.email,
		password: user.password,
		password_confirmation: user.confirmPassword,
	}
	if (user.middleName) {
		userPayload.middle_name = user.middleName;
	}
	if (user.phone) {
		userPayload.phone = user.phone;
	}
	return  userPayload;
};

export const formateUserResponseData = (user: IUserResponse): IUser => {
	const userPayload = {
		id: user.id || null,
		firstName: user.first_name,
		lastName: user.last_name,
		middleName: user.middle_name || '',
		email: user.email,
		phone: user.phone || '',
	}
	return  userPayload;
};

export const formateNumberQuantityText = (num: number, titles: string[]): string => {
	const cases = [2, 0, 1, 1, 1, 2];
	return titles[(num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5]];
};

export const formatPhoneNumber = (phone: string): string => {
	const cleaned = phone.replace(/\D/g, '');
	const match = cleaned.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/);
	if (match) {
		return ['+', match[1], ' (', match[2], ') ', match[3], '-', match[4], '-', match[5]].join('');
	}
	return '';
}